"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));

var _toPx = _interopRequireDefault(require("to-px"));

var _hexAndRgba = require("hex-and-rgba");

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var bgColorFromFullColor = function bgColorFromFullColor(fullColor) {
  var _hexToRgba = (0, _hexAndRgba.hexToRgba)(fullColor),
      _hexToRgba2 = _slicedToArray(_hexToRgba, 3),
      r = _hexToRgba2[0],
      g = _hexToRgba2[1],
      b = _hexToRgba2[2];

  return (0, _hexAndRgba.rgbaToHex)(r, g, b, 0.06);
};

var SeatRowComponent = function SeatRowComponent(_ref) {
  var seats = _ref.seats,
      width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      _ref$selectedSeats = _ref.selectedSeats,
      selectedSeats = _ref$selectedSeats === void 0 ? [] : _ref$selectedSeats,
      _ref$seatsPendingHold = _ref.seatsPendingHold,
      seatsPendingHold = _ref$seatsPendingHold === void 0 ? [] : _ref$seatsPendingHold,
      _ref$seatsPendingRele = _ref.seatsPendingRelease,
      seatsPendingRelease = _ref$seatsPendingRele === void 0 ? [] : _ref$seatsPendingRele,
      _ref$onSeatToggle = _ref.onSeatToggle,
      onSeatToggle = _ref$onSeatToggle === void 0 ? null : _ref$onSeatToggle,
      _ref$numberOfSeatsToS = _ref.numberOfSeatsToSelect,
      numberOfSeatsToSelect = _ref$numberOfSeatsToS === void 0 ? 0 : _ref$numberOfSeatsToS,
      seatInfoByPrice = _ref.seatInfoByPrice;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 'fit-content'
    }
  }, seats.map(function (s, i) {
    var seatInfo = seatInfoByPrice(s.priceInCents);
    var seatFree = s.exists && s.available && !!s.number; // Reina del Camino doesn't give number for non available seats

    var visibility = s.exists
    /* && !!s.number */
    ? 'visible' : 'hidden';

    var showRightSpace = function showRightSpace(index) {
      return index % 2 === 1 && index + 1 < seats.length;
    };

    var seatSelected = selectedSeats && selectedSeats.includes(s.number);
    var seatChangePending = seatsPendingHold && seatsPendingHold.includes(s.number) || seatsPendingRelease && seatsPendingRelease.includes(s.number);
    var fontWeight = 'bold';
    var seatColor = 'white';
    var seatBorderColor = seatInfo.freeColor;
    var color = 'gray';
    var cursor = onSeatToggle ? 'pointer' : 'inherit';
    var selectable = _checkTypes["default"]["function"](onSeatToggle) && !seatChangePending && (seatFree && selectedSeats.length + seatsPendingHold.length < numberOfSeatsToSelect || selectedSeats.includes(s.number));

    if (!seatFree) {
      seatColor = _Colors.seatMatrixBusyColor;
      seatBorderColor = _Colors.seatMatrixBusyColor;
      color = 'white'; // color = blackTextColor;

      fontWeight = 'bold';
    }

    if (seatSelected && !seatChangePending) {
      color = seatInfo.selectedColor;
      seatBorderColor = seatInfo.selectedColor;
      seatColor = bgColorFromFullColor(seatInfo.selectedColor); // seatColor = seatInfo.selectedColor;
      // seatColor = highlightedWidgetBackgroundColor;
      // seatBorderColor = primaryColor;

      fontWeight = 'bold';
    }

    if (onSeatToggle && !selectable) {
      cursor = 'not-allowed';
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      key: "seat_".concat(i, "_").concat(s.number),
      style: {
        margin: margin,
        width: width,
        height: height,
        borderRadius: 5,
        border: "solid 1.5px ".concat(seatBorderColor),
        backgroundColor: seatColor,
        visibility: visibility,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: color,
        cursor: cursor,
        fontWeight: fontWeight
      },
      onClick: selectable ? function () {
        onSeatToggle(s.number);
      } : undefined
    }, seatChangePending ? /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: '10%',
        width: '50%',
        height: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactLoaderSpinner["default"], {
      type: "Puff",
      width: "100%",
      height: "100%",
      color: _Colors.primaryColor
    }))) : s.number || 'x'), showRightSpace(i) && /*#__PURE__*/_react["default"].createElement("div", {
      key: "seat_".concat(i, "_space"),
      style: {
        margin: margin,
        marginLeft: 0,
        marginRight: 0,
        width: width,
        height: height,
        borderRadius: 5,
        backgroundColor: seatColor,
        visibility: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: seatFree ? 'gray' : 'white'
      }
    }, s.number));
  }));
};

var SeatMatrix = function SeatMatrix(_ref2) {
  var seatInfoByPrice = _ref2.seatInfoByPrice,
      seatMatrix = _ref2.seatMatrix,
      _ref2$selectedSeats = _ref2.selectedSeats,
      selectedSeats = _ref2$selectedSeats === void 0 ? [] : _ref2$selectedSeats,
      _ref2$seatsPendingHol = _ref2.seatsPendingHold,
      seatsPendingHold = _ref2$seatsPendingHol === void 0 ? [] : _ref2$seatsPendingHol,
      _ref2$seatsPendingRel = _ref2.seatsPendingRelease,
      seatsPendingRelease = _ref2$seatsPendingRel === void 0 ? [] : _ref2$seatsPendingRel,
      _ref2$onSeatToggle = _ref2.onSeatToggle,
      onSeatToggle = _ref2$onSeatToggle === void 0 ? null : _ref2$onSeatToggle,
      _ref2$numberOfSeatsTo = _ref2.numberOfSeatsToSelect,
      numberOfSeatsToSelect = _ref2$numberOfSeatsTo === void 0 ? 0 : _ref2$numberOfSeatsTo,
      t = _ref2.translator;
  var maxWidth = 50;
  var width = Math.min(Math.round((0, _toPx["default"])("".concat(Math.round(0.7 * 100 / (1 * seatMatrix.length)), "vh"))), maxWidth);
  var height = Math.round(4 * width / 5);
  var margin = Math.round(1 * height / 8);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: margin,
      margin: 15,
      backgroundColor: 'white',
      border: "solid 1.5px ".concat(_Colors.widgetBorderColor),
      borderRadius: '10px',
      width: 'fit-content',
      fontSize: '1.1rem',
      fontWeight: 'bold'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withDefaultFont)({
      textAlign: 'center',
      color: _Colors.discreetTextColor,
      marginTop: '5%',
      marginBottom: '5%',
      fontWeight: 600,
      fontSize: '1.05rem'
    })
  }, t('Bus front')), seatMatrix.map(function (row, i) {
    return /*#__PURE__*/_react["default"].createElement(SeatRowComponent, {
      key: "row_".concat(i),
      seatInfoByPrice: seatInfoByPrice,
      seats: row,
      width: width,
      height: height,
      margin: margin,
      selectedSeats: selectedSeats,
      seatsPendingHold: seatsPendingHold,
      seatsPendingRelease: seatsPendingRelease,
      onSeatToggle: onSeatToggle,
      numberOfSeatsToSelect: numberOfSeatsToSelect
    });
  }));
};

var _default = SeatMatrix;
exports["default"] = _default;